import { render, staticRenderFns } from "./UserPointsRecordList.vue?vue&type=template&id=1a0874f9&scoped=true&lang=pug&"
import script from "./UserPointsRecordList.vue?vue&type=script&lang=ts&"
export * from "./UserPointsRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0874f9",
  null
  
)

export default component.exports